"use client"

import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getCompeteCategories, getCompeteStages, storeCompeteProject } from "@/(front-desk)/utils/dataFetch"

export default function UserCompeteLayout({children}) {

    const dispatch = useDispatch()
    const compete = useSelector((state) => state.compete)
    const global = useSelector((state) => state.global)

    useEffect(() => {
        if (global.currentCompeteYear && compete.stages === null) {
            getCompeteStages(dispatch, global.currentCompeteYear)
        }
    }, [global.currentCompeteYear, compete.stages])

    useEffect(() => {
        if (global.currentCompeteYear && compete.categories === null) {
            getCompeteCategories()
        }
    }, [global.currentCompeteYear, compete.categories])

    useEffect(() => {
        if (global.currentCompeteYear && compete.draft === null) {
            storeCompeteProject("draft")
        }
    }, [global.currentCompeteYear, compete.draft])

    useEffect(() => {
        if (global.currentCompeteYear && compete.submitted === null) {
            storeCompeteProject("submitted")
        }
    }, [global.currentCompeteYear, compete.submitted])

    useEffect(() => {
        if (global.currentCompeteYear && compete.history === null) {
            storeCompeteProject("history")
        }
    }, [global.currentCompeteYear, compete.history])

    if (compete.stages) return (
        <>
        <title>參賽報名 - 放視大賞</title>
        {children}
        </>
    )
}